import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6975244"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cropper-content" }
const _hoisted_2 = { class: "cropper-box" }
const _hoisted_3 = { class: "cropper" }
const _hoisted_4 = { class: "footer-btn" }
const _hoisted_5 = { class: "scope-btn" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn",
  for: "uploads"
}, "选择", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload" }, null, -1))
const _hoisted_8 = { class: "show-preview" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_cropper = _resolveComponent("vue-cropper")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "图片上传",
      width: "1000px",
      top: '20px',
      "before-close": _ctx.handleClose
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createBlock(_component_vue_cropper, {
                ref: "cropper",
                img: _ctx.option.img,
                outputSize: _ctx.option.outputSize,
                outputType: _ctx.option.outputType,
                key: _ctx.random,
                info: _ctx.option.info,
                canScale: _ctx.option.canScale,
                autoCrop: _ctx.option.autoCrop,
                autoCropWidth: _ctx.option.autoCropWidth,
                autoCropHeight: _ctx.option.autoCropHeight,
                fixed: _ctx.option.fixed,
                fixedNumber: _ctx.option.fixedNumber,
                full: _ctx.option.full,
                fixedBox: _ctx.option.fixedBox,
                canMove: _ctx.option.canMove,
                canMoveBox: _ctx.option.canMoveBox,
                original: _ctx.option.original,
                centerBox: _ctx.option.centerBox,
                height: _ctx.option.height,
                infoTrue: _ctx.option.infoTrue,
                maxImgSize: _ctx.option.maxImgSize,
                enlarge: _ctx.option.enlarge,
                mode: _ctx.option.mode,
                onRealTime: _ctx.realTime,
                onImgLoad: _ctx.imgLoad
              }, null, 8, ["img", "outputSize", "outputType", "info", "canScale", "autoCrop", "autoCropWidth", "autoCropHeight", "fixed", "fixedNumber", "full", "fixedBox", "canMove", "canMoveBox", "original", "centerBox", "height", "infoTrue", "maxImgSize", "enlarge", "mode", "onRealTime", "onImgLoad"]))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("input", {
                  type: "file",
                  id: "uploads",
                  style: {"position":"absolute","clip":"rect(0 0 0 0)"},
                  accept: "image/png, image/jpeg, image/gif, image/jpg",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectImg($event)))
                }, null, 32),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  plain: "",
                  icon: "plus",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeScale(1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("放大")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  plain: "",
                  icon: "minus",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeScale(-1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("缩小")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  plain: "",
                  onClick: _ctx.rotateLeft
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("↺ 左旋转")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  plain: "",
                  onClick: _ctx.rotateRight
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("↻ 右旋转")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "success",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadImg('blob')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("上传"),
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              style: _normalizeStyle(_ctx.previews.div),
              class: "preview"
            }, [
              _createElementVNode("img", {
                src: _ctx.previews.url,
                style: _normalizeStyle(_ctx.previews.img)
              }, null, 12, _hoisted_9)
            ], 4)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
}